import { TextField } from '@mui/material';
import { Box } from '@mui/system';
import { Dispatch, SetStateAction, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import CustomButtonContained from 'src/components/CustomButton/CustomButtonContained';
import EditFormfeatureViews from 'src/components/EditFormfeatureViews/EditFormfeatureViews';
import { RootState } from 'src/redux-store/appStore';
import CustomModal from 'src/ui-component/customModal/CustomModal';
import { shouldShowEdit } from 'src/utils/CommonFunctions';

type ContentProps = {
  setIsOpenState?: (value: boolean) => void;
  applicationID?: string | number;
  UserID?: string;
  ApplicationStatus?: string;
  ApplicationNumber?: string;
  selectMultipleFiles?: boolean;
  switchTo?: string;
  setSwitchTo?: (value: string) => void;
  uploadDocsHide?: boolean;
  notificationReceiverUserID?: any;
  currentView?: string;
  setCurrentView?: Dispatch<SetStateAction<string>>;
};

export default function Content({
  setIsOpenState,
  applicationID,
  UserID,
  ApplicationStatus,
  ApplicationNumber,
  selectMultipleFiles = false,
  switchTo,
  setSwitchTo,
  uploadDocsHide,
  notificationReceiverUserID
}: ContentProps) {
  const messageBodyRef = useRef();
  const [loading, setLoading] = useState<boolean>(false);
  const [IsOpen, setIsOpen] = useState<boolean>(false);
  const currentPermitDetails = useSelector(
    (store: RootState) => store.currentPermit.currentPermitDetails
  );
  const isManager =
    currentPermitDetails?.currentPermitUserRole === 'Manager' ||
    currentPermitDetails?.currentPermitUserRole === 'Front Desk Manager';
  const handleMessageChange = (e) => {
    messageBodyRef.current = e.target.value;
  };

  const sendMsgButtonValidator = {
    ApplicationStatus: ApplicationStatus
  };

  return (
    <Box mt={3}>
      {!switchTo ? (
        <Box>
          {!uploadDocsHide && Number(currentPermitDetails.id) !== 9 && (
            <>
              {selectMultipleFiles ? (
                <CustomButtonContained
                  sx={{ width: { xs: '100%', sm: 'auto' } }}
                  onClick={() => setIsOpenState(true)}
                  title={'Upload/View Document'}
                />
              ) : currentPermitDetails.id !== 8 ? (
                <CustomButtonContained
                  sx={{ width: { xs: '100%', sm: 'auto' } }}
                  onClick={() => setSwitchTo('Upload/View Document')}
                  title={'Upload/View Document'}
                />
              ) : (
                ''
              )}
            </>
          )}

          {!uploadDocsHide && (
            <>
              {isManager &&
                ApplicationStatus !== 'Draft' &&
                !shouldShowEdit(sendMsgButtonValidator) && (
                  <CustomButtonContained
                    sx={{
                      ml:
                        currentPermitDetails.id !== 8 &&
                        currentPermitDetails.id !== 9
                          ? 2
                          : 0,
                      width: { xs: '100%', sm: 'auto' },
                      mt: { xs: 1.5, sm: 'auto' }
                    }}
                    onClick={() => setIsOpen(true)}
                    title={'Send Message'}
                  />
                )}
            </>
          )}

          {!uploadDocsHide && (
            <>
              {ApplicationStatus !== 'Draft' && (
                <CustomButtonContained
                  sx={{
                    ml: { xs: 0, sm: 2 },
                    width: { xs: '100%', sm: 'auto' },
                    mt: { xs: 1.5, sm: 'auto' }
                  }}
                  title={'View Message History'}
                  onClick={() => setSwitchTo('View Message History')}
                />
              )}
            </>
          )}

          {!uploadDocsHide && (
            <>
              {ApplicationStatus !== 'Draft' && (
                <CustomButtonContained
                  sx={{
                    ml: { xs: 0, sm: 2 },
                    width: { xs: '100%', sm: 'auto' },
                    mt: { xs: 1.5, sm: 'auto' }
                  }}
                  title={'View Payment History'}
                  onClick={() => setSwitchTo('View Payment History')}
                />
              )}
            </>
          )}
        </Box>
      ) : (
        <EditFormfeatureViews
          switchTo={switchTo}
          setSwitchTo={setSwitchTo}
          applicationDetails={{
            TownshipID: currentPermitDetails?.townshipId,
            applicationID: applicationID,
            UserID: UserID,
            ApplicationStatus: ApplicationStatus
          }}
        />
      )}

      <CustomModal
        title={'Send Message'}
        IsOpen={IsOpen}
        setIsOpen={setIsOpen}
        actionButtons={['Cancel', 'Send']}
        loading={loading}
        messageBodyRef={messageBodyRef}
        setLoading={setLoading}
        ApplicationID={applicationID}
        applicationNumber={ApplicationNumber}
        applicationDetails={{
          UserID: notificationReceiverUserID
            ? notificationReceiverUserID
            : UserID
        }}
        content={
          <TextField
            className="txtArea"
            label="Message"
            placeholder="Message"
            name="message"
            multiline
            onChange={(e) => handleMessageChange(e)}
            sx={{ width: '600px' }}
            rows={3}
          />
        }
      />    
    </Box>
  );
}
